import * as Sentry from "@sentry/react-router";
import { HydratedRouter } from "react-router/dom";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";

const sentryTracing = Sentry.reactRouterTracingIntegration();

Sentry.init({
    dsn: "https://bb8e5cd911e0c40f7681908285be1dcc@o4508062953832448.ingest.us.sentry.io/4508272739352576",
    tracesSampleRate: 1,

    integrations: [sentryTracing, Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true
    })],

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1
})

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter
        instrumentations={[sentryTracing.clientInstrumentation]}
        onError={Sentry.sentryOnError}
      />
    </StrictMode>
  );
});
